export const UPDATE_THANK_YOU_PAGE_DATA = 'UPDATE_THANK_YOU_PAGE_DATA';

export const updateThankYouPageData = data => ({
  type: UPDATE_THANK_YOU_PAGE_DATA,
  payload: data
});
